<template>
    <div v-if="items" :class="['custom-radio', type, customClass]">
        <custom-radio-item
            v-for="item in items"
            :key="item.value"
            :value="item.value"
            :cls="item.cls"
            :text="showText ? item.text : ''"
            :color="item.color"
            :icon="item.icon"
            :image="item.image"
            :imageWidth="item.imageWidth"
            :imageHeight="item.imageHeight"
            :disabled="item.disabled"
            :ref="getRef(item.value)"
            @click="handleItemClick(item)"
            :selected="isSelected(item)"/>
    </div>
</template>

<script>
import CustomRadioItem from "../atoms/CustomRadioItem.vue";

export default {
    name: "CustomRadio",
    props: {
        value: {
            type: Object,
            default: null
        },
        items: Array,
        type: {
            type: String,
            required: false,
            default: 'grid'
        },
        customClass: {
            type: String|Array,
            required: false,
            default: ''
        },
        showText: {
            type: Boolean,
            required: false,
            default: true
        }
    },
    data() {
        return {
            selectedItem: this.value
        };
    },
    watch: {
        value: function (value) {
            this.selectedItem = value;
        }
    },
    components: {
        'custom-radio-item': CustomRadioItem
    },
    methods: {
        getRef(value) {
            return value + 'CustomRadioItem';
        },
        handleItemClick(item, emit  = true) {
            this.selectedItem = item;
            if(emit) {
                this.$emit('input', this.selectedItem);
            }
        },
        isSelected(item) {
            return this.selectedItem === item;
        },
        selectItem(itemValue, emit = true) {
            const item = this.items.find(item => item.value === itemValue);
            if (item) {
                this.handleItemClick(item, emit);
            }
        }
    },
    mounted() {
        if (this.value) {
            this.selectItem(this.value.value, false);
        }
    }
}
</script>
